/* eslint-disable jira/filename-case */
import { loadWrmResources } from './load-wrm-resources.tsx';
import { type BatchDetailsResponseType, SHOULD_LOG_ERROR } from './shared.tsx';

export const wrmRequireWithPrefetch = async (
	wrmKeys: string[],
	batchUrl: BatchDetailsResponseType,
	shouldLogError: boolean = SHOULD_LOG_ERROR,
): Promise<void> => loadWrmResources({ wrmKeys, shouldLogError, batchUrl });
